module.exports = __webpack_public_path__ + "src/client/assets/img/download-appstore.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/img/download-appstore.png
// module id = 1202
// module chunks = 0